import PressRelease from "./PressRelease";

export default PressRelease;